import { render, staticRenderFns } from "./ClassVisitBehavior.vue?vue&type=template&id=1e5e154a&scoped=true&"
import script from "./ClassVisitBehavior.vue?vue&type=script&lang=js&"
export * from "./ClassVisitBehavior.vue?vue&type=script&lang=js&"
import style0 from "./ClassVisitBehavior.vue?vue&type=style&index=0&id=1e5e154a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e5e154a",
  null
  
)

export default component.exports